<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="requirementForm" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
             label-width="150px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="需求主体名称" prop="Requirement.mainBody">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.mainBody"
                      :clearable="true" placeholder="需求主体名称"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.mainBody}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主体联系人" prop="Requirement.mainContact">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.mainContact"
                      :clearable="true" placeholder="需求主体联系人"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.mainContact}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主体手机" prop="Requirement.mainPhone">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.mainPhone"
                      :clearable="true" placeholder="需求主体手机"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.mainPhone}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="座机" prop="Requirement.landline">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.landline"
                      :clearable="true" placeholder="座机"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.landline}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电子邮箱" prop="Requirement.eMail">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.eMail"
                      :clearable="true" placeholder="电子邮箱"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.eMail}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行业" prop="Requirement.industryId">
            <el-cascader class="input-item" v-if="!readOnly" v-model="requirementForm.industryId.value" :options="requirementForm.industryId.impl.dropdownList" filterable
                         :clearable="true" :show-all-levels="false" placeholder="行业"
                         :props="{value: 'id', label: 'name', checkStrictly: true}"
                         @visible-change="requirementForm.industryId.impl.onVisibleChange"
                         @change="onIndustryIdValueChange"
            />
            <span class="input-item input-label" v-else>{{(formData.Requirement.industryIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="需求类型" prop="Requirement.subjectType">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.Requirement.subjectType" :clearable="true" filterable
                       placeholder="需求类型" :loading="requirementForm.subjectType.impl.loading"
                       @visible-change="requirementForm.subjectType.impl.onVisibleChange"
                       @change="onSubjectTypeValueChange">
              <el-option v-for="item in requirementForm.subjectType.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Requirement.subjectTypeDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地区" prop="Requirement.areaId">
            <el-cascader class="input-item" v-if="!readOnly" v-model="requirementForm.areaId.value" :options="requirementForm.areaId.impl.dropdownList" filterable
                         :clearable="true" :show-all-levels="false" placeholder="地区"
                           :props="{value: 'id', label: 'name'}"
                         @visible-change="requirementForm.areaId.impl.onVisibleChange"
                         @change="onAreaIdValueChange"
            />
            <span class="input-item input-label" v-else>{{(formData.Requirement.areaIdDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="详细地址" prop="Requirement.address">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.address"
                      :clearable="true" placeholder="详细地址"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.address}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="需求主题" prop="Requirement.subjectName">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.subjectName"
                      :clearable="true" placeholder="需求主题"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.subjectName}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关键词" prop="Requirement.keyWord">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.keyWord"
                      :clearable="true" placeholder="关键词"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.keyWord}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="需求描述" prop="Requirement.requirementDesc">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.Requirement.requirementDesc"
                      type="textarea"
                      :autosize="{minRows: 1, maxRows: 4}"
                      :clearable="true" placeholder="需求描述"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.requirementDesc}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="有效期" prop="Requirement.validity">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.Requirement.validity" :clearable="true" filterable
                       placeholder="有效期" :loading="requirementForm.validity.impl.loading"
                       @visible-change="requirementForm.validity.impl.onVisibleChange"
                       @change="onValidityValueChange">
              <el-option v-for="item in requirementForm.validity.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Requirement.validityDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否公开" prop="Requirement.isOpen">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.Requirement.isOpen" :clearable="true" filterable
                       placeholder="是否公开" :loading="requirementForm.isOpen.impl.loading"
                       @visible-change="requirementForm.isOpen.impl.onVisibleChange"
                       @change="onIsOpenValueChange">
              <el-option v-for="item in requirementForm.isOpen.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Requirement.isOpenDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if=" formData.Requirement.createType==='2'">
          <el-form-item label="是否帮助上传" prop="Requirement.isHelp">
            <el-select class="input-item" v-if="!readOnly" v-model="formData.Requirement.isHelp" :clearable="true" filterable
                       placeholder="是否帮助上传" :loading="requirementForm.isHelp.impl.loading"
                       :disabled="!(userInfo.isSpecial && userInfo.isSpecial==='2')"
                       @visible-change="requirementForm.isHelp.impl.onVisibleChange"
                       >
              <el-option v-for="item in requirementForm.isHelp.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Requirement.isOpenDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="对接状态" prop="Requirement.isDocking">
            <el-select class="input-item" v-if="readOnly" v-model="formData.Requirement.isDocking" :clearable="true"
                       filterable
                       placeholder="对接状态" :loading="requirementForm.isDocking.impl.loading"
                       @visible-change="requirementForm.isDocking.impl.onVisibleChange"
                       @change="onIsDockingValueChange">
              <el-option v-for="item in requirementForm.isDocking.impl.dropdownList" :key="item.id"
                         :value="item.id" :label="item.name"
              />
            </el-select>
            <span class="input-item input-label" v-else>{{(formData.Requirement.isDockingDictMap || {}).name}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="formData.Requirement.isDocking===1">
          <el-form-item label="对接详情" prop="Requirement.dockingDesc">
            <el-input type="textarea" :rows="2" class="input-item" v-if="readOnly"
                      v-model="formData.Requirement.dockingDesc"
                      :clearable="true" placeholder="对接详情"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.dockingDesc}}</span>
          </el-form-item>
        </el-col>
<!--        <el-col :span="12">-->
<!--          <el-form-item label="对接专家" prop="Requirement.specialistIds">-->
<!--            <el-select class="input-item" v-if="!readOnly" v-model="formData.Requirement.specialistIds" :clearable="true" filterable-->
<!--                       placeholder="对接专家" :loading="requirementForm.specialistIds.impl.loading"-->
<!--                       @visible-change="requirementForm.specialistIds.impl.onVisibleChange"-->
<!--                       @change="onSpecialistIdsValueChange">-->
<!--              <el-option v-for="item in requirementForm.specialistIds.impl.dropdownList" :key="item.id"-->
<!--                         :value="item.id" :label="item.name"-->
<!--              />-->
<!--            </el-select>-->
<!--            <span class="input-item input-label" v-else>{{(formData.Requirement.specialistIdsDictMap || {}).name}}</span>-->

<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="12">
          <el-form-item label="附件照片" prop="Requirement.attachedImages">

            <el-upload v-if="!readOnly"
            class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
            :action="getUploadActionUrl('/admin/app/requirement/upload')"
            :data="{fieldName: 'attachedImages', asImage: true}"
            :on-success="onAttachedImagesUploadSuccess"
            :on-remove="onAttachedImagesRemoveFile"
            :before-upload="pictureFile"
            :on-error="onUploadError"
            :show-file-list="true"
            :on-preview="handlePreview"
            :limit="requirementForm.attachedImages.impl.maxCount"
            :on-exceed="onUploadLimit"
            :file-list="requirementForm.attachedImages.impl.fileList"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <el-image v-for="item in parseUploadData(formData.Requirement.attachedImages, {id: formData.Requirement.id,
                  fieldName: 'attachedImages', asImage: true})"
                        :preview-src-list="getPictureList(formData.Requirement.attachedImages, {id: formData.Requirement.id, fieldName: 'attachedImages', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" fit="scale-down">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>

          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="readOnly">
          <el-form-item label="审核不通过原因" prop="Requirement.auditDesc">
            <el-input type="textarea" :rows="2" class="input-item" v-if="formData.Requirement.auditStatus==='0' &&
             userInfo.isSpecial!='1'"
                      v-model="formData.Requirement.auditDesc"
                      :clearable="true" placeholder="审核不通过原因"
            />
            <span class="input-item input-label" v-else>{{formData.Requirement.auditDesc}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24" class="gutter-bottom">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize"  v-if="readOnly"
                       @click="onUpdateClick()">
              保存
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize"  v-if="formData.Requirement.auditStatus==='0' && userInfo.isSpecial!='1'"
                       @click="audit('1')" >
              审核通过
            </el-button>
            <el-button type="primary" :size="defaultFormItemSize"  v-if="formData.Requirement.auditStatus==='0' && userInfo.isSpecial!='1'"
                       @click="audit('-1')">
              审核不通过
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
  </div>
</template>

<script>
/* eslint-disable-next-line */
  import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
  import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
  import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
  import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
  import { RequirementController, DictionaryController } from '@/api';
import specialistSelect from '@/components/specialistSelect';
export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')

  },
  name: 'requirementForm',
  props: {
    id: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      readOnly: false,
      specialistNameKey: 0,
      formData: {
        Requirement: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          subjectName: undefined,
          subjectType: undefined,
          industryId: undefined,
          userName: undefined,
          keyWord: undefined,
          userPhone: undefined,
          requirementDesc: undefined,
          attachedImages: undefined,
          specialistIds: undefined,
          specialistNames: undefined,
          isDocking: undefined,
          dockingDesc: undefined,
          mainContact: undefined,
          areaId: undefined,
          auditDesc: undefined,
          auditStatus: undefined,
          createType: undefined,
          requirementRelate: {
          },
          sysUser: {
            userId: undefined,
            loginName: undefined,
            password: undefined,
            deptId: undefined,
            showName: undefined,
            userType: undefined,
            headImageUrl: undefined,
            userStatus: undefined,
            deletedFlag: undefined,
            createUserId: undefined,
            updateUserId: undefined,
            createTime: undefined,
            updateTime: undefined
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'Requirement.mainContact': [
          {required: true, message: '请输入需求主体联系人', trigger: 'blur'}
        ],
        'Requirement.mainPhone': [
          {required: true, message: '请输入需求主体手机', trigger: 'blur'}
        ],
        'Requirement.mainBody': [
          {required: true, message: '请输入需求主体名称', trigger: 'blur'}
        ],
        'Requirement.userPhone': [
          {required: true, message: '请输入联系电话', trigger: 'blur'}
        ],
        'Requirement.userName': [
          {required: true, message: '请输入用户名', trigger: 'blur'}
        ],
        'Requirement.industryId': [
          {required: true, message: '请输入行业', trigger: 'blur'}
        ],
        'Requirement.subjectType': [
          {required: true, message: '请输入需求类型', trigger: 'blur'}
        ],
        'Requirement.subjectName': [
          {required: true, message: '请输入需求主题', trigger: 'blur'}
        ],
        'Requirement.keyWord': [
          {required: true, message: '请输入关键词', trigger: 'blur'}
        ],
        'Requirement.requirementDesc': [
          {required: true, message: '请输入需求描述', trigger: 'blur'}
        ],
        'Requirement.specialistNames': [
          {required: true, message: '请输入专家'}
        ],
        'Requirement.areaId': [
          {required: true, message: '请选择地区', trigger: 'change'}
        ],
        'Requirement.isDocking': [
          {required: true, message: '请选择是否对接', trigger: 'change'}
        ],
        'Requirement.dockingDesc': [
          {required: true, message: '请输入对接详情', trigger: 'change'}
        ]
      },
      requirementForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        areaId: {
          impl: new DropdownWidget(this.loadAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        subjectType: {
          impl: new DropdownWidget(this.loadSubjectTypeDropdownList)
        },
        validity: {
          impl: new DropdownWidget(this.loadValidityDropdownList)
        },
        isOpen: {
          impl: new DropdownWidget(this.loadIsOpenDropdownList)
        },
        isHelp: {
          impl: new DropdownWidget(this.loadIsHelpDropdownList)
        },
        attachedImages: {
          impl: new UploadWidget(5)
        },
        menuBlock: {
          isInit: false
        },
        isDocking: {
          impl: new DropdownWidget(this.loadIsDockingDropdownList)
        },
        specialistIds: {
          impl: new DropdownWidget(this.loadSpecialistIdsDropdownList)
        },

        isInit: false
      },
      userInfo: {}
    }
  },
  methods: {
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
       * 需求类型下拉数据获取函数
       */
    loadSubjectTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictRSTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 需求类型选中值改变
       */
    onSubjectTypeValueChange (value) {
    },

    onSelectWarehouse () {
      this.specialistNameKey += 1
      this.$dialog.show('选择专家', specialistSelect, {
        area: ['1000px', '600px']
      }, {}).then(res => {
        // alert(JSON.stringify(res))
        this.formData.Requirement.specialistIds = res.id
        this.formData.Requirement.specialistNames = res.specialistName
        this.$forceUpdate()
      }).catch(e => {
      });
    },
    clearSpecialist () {
      this.formData.Requirement.specialistIds = ''
      this.formData.Requirement.specialistNames = ''
      this.$forceUpdate()
    },
    /**
       * 指派专家下拉数据获取函数
       */
    loadSpecialistIdsDropdownList () {
      return new Promise((resolve, reject) => {
        let params = { auditStatus: '1'};
        DictionaryController.dictSpecialist(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 指派专家选中值改变
       */
    onSpecialistIdsValueChange (value) {
    },
    /**
       * 行业下拉数据获取函数
       */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
       * 行业选中值改变
       */
    onIndustryIdValueChange (value) {
      this.formData.Requirement.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 有效期下拉数据获取函数
     */
    loadValidityDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictValidityDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 有效期选中值改变
     */
    onValidityValueChange (value) {
    },
    /**
     * 是否公开下拉数据获取函数
     */
    loadIsOpenDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictOpenDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadIsHelpDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否公开选中值改变
     */
    onIsOpenValueChange (value) {
    },
    /**
     * 地区id下拉数据获取函数
     */
    loadAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaStreet(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 地区id选中值改变
     */
    onAreaIdValueChange (value) {
      this.formData.Requirement.areaId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 对接状态下拉数据获取函数
     */
    loadIsDockingDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIsDockingDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 对接状态选中值改变
     */
    onIsDockingValueChange (value) {
    },
    /**
       * 更新需求信息编辑页面
       */
    refreshRequirementForm (reloadData = false) {
      this.loadRequirementData().then(res => {
        if (!this.requirementForm.isInit) {
          // 初始化下拉数据
          this.requirementForm.industryId.impl.onVisibleChange(true).then(res => {
            this.requirementForm.industryId.value = findTreeNodePath(res, this.formData.Requirement.industryId, 'id');
          }).catch(e => {});
        }
        this.requirementForm.isInit = true;
      }).catch(e => {});
    },
    /**
       * 保存
       */
    onUpdateClick () {
      this.$refs.requirementForm.validate((valid) => {
        if (!valid) return;
        this.formData.Requirement.keyWord = this.formData.Requirement.keyWord.replaceAll('，', ',')
        let params = {
          requirementDto: {
            // specialistIds: this.formData.Requirement.specialistIds,
            // specialistNames: this.formData.Requirement.specialistNames,
            // attachedImages: this.formData.Requirement.attachedImages,
            // userName: this.formData.Requirement.userName,
            // userPhone: this.formData.Requirement.userPhone,
            // id: this.formData.Requirement.id,
            // orgCode: this.formData.Requirement.orgCode,
            // subjectName: this.formData.Requirement.subjectName,
            // subjectType: this.formData.Requirement.subjectType,
            // industryId: this.formData.Requirement.industryId,
            // keyWord: this.formData.Requirement.keyWord,
            // requirementDesc: this.formData.Requirement.requirementDesc
            ...this.formData.Requirement
          }
        };

        if (this.formData.Requirement.id !== null && this.formData.Requirement.id !== undefined) {
          RequirementController.update(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        } else {
          RequirementController.add(this, params).then(res => {
            this.$message.success('保存成功');
            this.onCancel(true);
          }).catch(e => {});
        }
      });
    },
    audit (auditStatus) {
      if (auditStatus === '-1') {
        if (!this.formData.Requirement.auditDesc) {
          this.$message.error('请填写不通过原因');
          return
        }
      } else {
        this.formData.Requirement.auditDesc = '同意'
      }
      this.formData.auditStatus = auditStatus
      let params = {
        requirementDto: {
          ...this.formData.Requirement,
          auditStatus: auditStatus
        }
      };
      RequirementController.update(this, params).then(res => {
        this.$message.success('审核成功');
        this.onCancel(true);
      }).catch(e => {});
    },
    onResume () {
      this.refreshRequirementForm(true);
    },
    /**
       * 获取需求对接表详细信息
       */
    loadRequirementData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.Requirement.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          RequirementController.view(this, params).then(res => {
            this.formData.Requirement = {...res.data, isDatasourceInit: true};
            if (this.formData.Requirement.subjectTypeDictMap && this.requirementForm.subjectType.impl.dirty) {
              this.requirementForm.subjectType.impl.dropdownList = [this.formData.Requirement.subjectTypeDictMap];
            }
            let attachedImagesDownloadParams = {
              id: this.formData.Requirement.id,
              fieldName: 'attachedImages',
              asImage: true
            }
            this.requirementForm.attachedImages.impl.fileList = this.parseUploadData(this.formData.Requirement.attachedImages, attachedImagesDownloadParams);
            if (this.formData.Requirement.specialistIdsDictMap && this.requirementForm.specialistIds.impl.dirty) {
              // this.requirementForm.specialistIds.impl.dropdownList = [this.formData.Requirement.specialistIdsDictMap];
              this.formData.Requirement.specialistNames = this.formData.Requirement.specialistIdsDictMap.name
              // this.formData.requirementForm.specialistIds = this.formData.Requirement.specialistIds
              // this.$forceUpdate()
            }
            if (this.formData.Requirement.industryIdDictMap && this.requirementForm.industryId.impl.dirty) {
              this.requirementForm.industryId.impl.dropdownList = [this.formData.Requirement.industryIdDictMap];
            }
            if (this.formData.Requirement.industryId) this.requirementForm.industryId.value = [this.formData.Requirement.industryId];
            if (this.formData.Requirement.isDockingDictMap && this.requirementForm.isDocking.impl.dirty) {
              this.requirementForm.isDocking.impl.dropdownList = [this.formData.Requirement.isDockingDictMap];
            }
            if (this.formData.Requirement.areaIdDictMap && this.requirementForm.areaId.impl.dirty) {
              this.requirementForm.areaId.impl.dropdownList = [this.formData.Requirement.areaIdDictMap];
            }
            if (this.formData.Requirement.areaId) this.requirementForm.areaId.value = [this.formData.Requirement.areaId];
            this.requirementForm.isHelp.impl.onVisibleChange(true).catch(e => {});
            this.requirementForm.isOpen.impl.onVisibleChange(true).catch(e => {});
            this.requirementForm.validity.impl.onVisibleChange(true).catch(e => {});
            if (this.formData.Requirement.auditStatus === '1') {
              this.readOnly = true
            }
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.Requirement.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
       * 附件照片上传成功
       */
    onAttachedImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.requirementForm.attachedImages.impl.onFileChange(file, fileList);
        this.formData.Requirement.attachedImages = this.fileListToJson(this.requirementForm.attachedImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
       * 移除附件照片
       */
    onAttachedImagesRemoveFile (file, fileList) {
      this.requirementForm.attachedImages.impl.onFileChange(file, fileList);
      this.formData.Requirement.attachedImages = this.fileListToJson(this.requirementForm.attachedImages.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
       * 重置表单数据
       */
    resetFormData () {
      this.formData = {
        Requirement: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          subjectName: undefined,
          subjectType: undefined,
          industryId: undefined,
          userName: undefined,
          keyWord: undefined,
          userPhone: undefined,
          requirementDesc: undefined,
          attachedImages: undefined,
          specialistIds: undefined,
          specialistNames: undefined,
          isDocking: undefined,
          requirementRelate: {
          },
          sysUser: {
            userId: undefined,
            loginName: undefined,
            password: undefined,
            deptId: undefined,
            showName: undefined,
            userType: undefined,
            headImageUrl: undefined,
            userStatus: undefined,
            deletedFlag: undefined,
            createUserId: undefined,
            updateUserId: undefined,
            createTime: undefined,
            updateTime: undefined
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshRequirementForm();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
    this.userInfo = this.$store.state.userInfo
    // console.log(this.userInfo)
  },
  watch: {
  }
}
</script>
